export default __webpack_public_path__ + "static/media/nft-7.62df1ab1.png";